import { Directive, Input, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { PermissionService } from "./permission-service.service";
import { PermissionType } from "./PermissionType.enum";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[permission]'
})
export class PermissionDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input('permission') functionName: string = '';
  @Input('permissionTypes') types: PermissionType[] = [];

  constructor(
    private el: ElementRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    // Stay hidden until permissions load, otherwise the element flashes for users without access
    this.el.nativeElement.style.display = 'none';

    if (!this.functionName || !this.types?.length) {
      return;
    }

    this.permissionService.hasAnyPermission(this.functionName, this.types)
      .pipe(takeUntil(this.destroy$))
      .subscribe(hasPermission => {
        this.el.nativeElement.style.display = hasPermission ? '' : 'none';
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
